import React from "react";

const DingerDappContext = React.createContext();

export default DingerDappContext;
